import React from 'react';
import { BlockDataForm } from '@plone/volto/components';
import { useIntl } from 'react-intl';
import { MultiButtonsBlockSchema } from './schema';
import type { MultiButtonsBlockData } from './index';

interface Props {
  data: MultiButtonsBlockData;
  block: string;
  onChangeBlock: (id: string, data: MultiButtonsBlockData) => void;
  [key: string]: any;
}

const Data: React.FC<Props> = (props) => {
  const { data, block, onChangeBlock } = props;
  const intl = useIntl();
  const schema = MultiButtonsBlockSchema({
    ...props,
    intl,
    formData: data,
  } as any);

  const onChangeField = (id: string, value: any) => {
    if (id === 'buttons') {
      const prevCount = Array.isArray(data.buttons) ? data.buttons.length : 0;
      const nextButtons = Array.isArray(value) ? value : [];
      const nextCount = nextButtons.length;

      const currentMax =
        Number.isFinite(data.maxColumns) && (data.maxColumns as number) > 0
          ? Math.floor(data.maxColumns as number)
          : 0;

      const shouldTrackMax =
        currentMax === 0 || (prevCount > 0 && currentMax === prevCount);

      const nextMaxColumns =
        currentMax > nextCount || shouldTrackMax
          ? Math.max(1, nextCount)
          : currentMax;

      onChangeBlock(block, {
        ...data,
        buttons: nextButtons,
        maxColumns: nextMaxColumns,
      });
      return;
    }

    onChangeBlock(block, {
      ...data,
      [id]: value,
    });
  };

  return (
    <BlockDataForm
      schema={schema}
      title={schema.title}
      onChangeField={onChangeField}
      formData={data}
      block={block}
    />
  );
};

export default Data;
